module.exports = __webpack_public_path__ + "img/circle-plus.b0624194.svg";